// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3OA9W","noInteraction":"EventWrapper_noInteraction__TO2DG"};